import React, { useContext, useRef, useState } from 'react'
import DocumentUploadForm, { DocumentUploadFormButtonsOverride } from '@Components/DocumentUploadForm'
import { Maybe } from '@App/common/types'
import { StoresContext } from '@App/contexts'
import './index.scss'
import { generateCatalogTransferDocumentUploadUrl } from '@App/api/routes/rightsholder/catalog-transfer'
import Button from '@Components/Buttons/Button'
import { DocumentToUpload, UploadedDocument } from '@Entities/document/document-to-upload'
import UploadDocumentStepHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/UploadDocumentStep/UploadDocumentStepHeader'
import _ from 'lodash'

const CATALOG_TRANSFER_FORM_ACCEPTED_FILE_TYPES = ['.docx', '.doc', '.xls', '.xlsx', '.pdf']
const CATALOG_TRANSFER_FORM_MAX_FILE_SIZE_IN_BYTES = 50 * 1024 * 1024

const UploadDocumentStep = () => {
    const { catalogTransferWizardStore, rightsholderStore } = useContext(StoresContext)
    const documentUploadFormButtonsOverrideRef = useRef<DocumentUploadFormButtonsOverride>(null)
    const [areFilesStaged, setAreFilesStaged] = useState<boolean>(false)

    const onDoneClicked = async () => {
        await catalogTransferWizardStore.onDocumentsUploaded()
        setAreFilesStaged(false)
    }

    const generateS3PresignedUrl = async (fileName: string, fileSize: number, fileDescription: Maybe<string>) => {
        const response = await generateCatalogTransferDocumentUploadUrl(
            rightsholderStore.currentRightsholderId,
            catalogTransferWizardStore.currentTransferId,
            'DOCUMENTATION',
            fileName,
            fileSize,
            fileDescription
        )
        return _.omit(response.data, 'catalogTransferMemberUploadId')
    }

    const existingDocs: UploadedDocument[] =
        catalogTransferWizardStore.currentCatalogTransfer?.uploadedDocs
            .filter((doc) => doc.uploadType === 'DOCUMENTATION')
            .map((doc) => ({
                memberUploadId: doc.memberUploadId,
                name: doc.name,
                size: doc.size,
                description: doc.description,
                lastModified: doc.createdAt,
            })) || []

    return (
        <div className="ct-upload-document-step ct-wizard-step-container">
            <DocumentUploadForm
                title={<UploadDocumentStepHeader />}
                displayConfig={{ showDescription: false, hideUploadButtons: true }}
                onUpload={onDoneClicked}
                onFileStaged={(files: DocumentToUpload[]) => setAreFilesStaged(files.length !== 0)}
                allowedFilesConfig={{
                    allowedFileTypes: CATALOG_TRANSFER_FORM_ACCEPTED_FILE_TYPES,
                    maximumFileSizeInBytes: CATALOG_TRANSFER_FORM_MAX_FILE_SIZE_IN_BYTES,
                }}
                generateS3PresignedUrl={generateS3PresignedUrl}
                ref={documentUploadFormButtonsOverrideRef}
                completedUploadConfig={{
                    uploadedDocuments: existingDocs,
                    allowAdditionalUploads: true,
                }}
            />
            {areFilesStaged && (
                <Button
                    mainColor
                    type="primary"
                    onClick={() => documentUploadFormButtonsOverrideRef.current?.uploadDocuments()}
                >
                    {catalogTransferWizardStore.currentCatalogTransfer?.uploadedDocs.some(
                        (doc) => doc.uploadType === 'DOCUMENTATION'
                    )
                        ? 'Upload more'
                        : 'Upload Documents'}
                </Button>
            )}
        </div>
    )
}

export default UploadDocumentStep
